export default {
  heading: "'Lexend', 'Times New Roman', Times, serif",
  body: "'Lexend', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Ubuntu, 'Helvetica Neue', Oxygen, Cantarell, sans-serif",
}
